// extracted by mini-css-extract-plugin
export default {"form":"SuscribeToForm_form__AIoWD","title":"SuscribeToForm_title__Ts1vu","group":"SuscribeToForm_group__Mj7Uz","btn":"SuscribeToForm_btn__0pASI"};